module.exports = __webpack_public_path__ + "img/98_8.67ff5c37.png";